/* global axios */
import ApiClient from '../ApiClient';

// Teletel-owned branding setting (widget / survey / help-centre footer).
// Independent of the premium disable_branding flag, which the nightly plan
// reconciliation clears; the value lives under account.settings and is written
// only through this endpoint. See Teletel::Branding server-side.
class TeletelBrandingAPI extends ApiClient {
  constructor() {
    super('branding', { accountScoped: true });
  }

  baseUrl() {
    return `/teletel${super.baseUrl()}`;
  }

  show() {
    return axios.get(this.url);
  }

  // payload: { mode, text, url } - text/url only matter in custom mode and the
  // server validates them (text <= 80, url http(s) only).
  update(payload) {
    return axios.patch(this.url, payload);
  }
}

export default new TeletelBrandingAPI();
